import { type Ref, computed, ref } from 'vue'

import { navigationAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

export function useProductListSideNavigation(
  id: string,
  isExpanded: Ref<boolean> = ref(true),
) {
  const { data, pending } = useHttpFetch(
    navigationAPI.getProductListNavigation,
    {
      queryParams: { id },
    },
  )

  const parent = computed(() => {
    if (!data.value) {
      return []
    }

    return data.value.parent_nav
  })
  const children = computed(() => {
    if (!data.value) {
      return []
    }

    return data.value.children
  })

  const visibleChildren = computed(() => {
    return isExpanded.value ? children.value : children.value.slice(0, 5)
  })

  return { pending, parent, visibleChildren, children }
}
